module.exports = __webpack_public_path__ + "img/babycar_g.171a3f27.png";